//Calculate windows width and height
function viewport() {
  return { width: window.innerWidth, height: window.innerHeight };
}

//Find biggest element
function getBiggestHeight(array) {
  let maxHeight = 0;

  array.forEach(target => {
    const targetHeight = target.offsetHeight;
    if (targetHeight > maxHeight) {
      maxHeight = targetHeight;
    }
  });

  return maxHeight;
}

//Remove class
function replaceCSSClass(element, oldClassName, newClassName) {
  // Iterate through all classes of the element
  element.classList.forEach(className => {
    // If the class starts with oldClassName, remove it
    if (className.startsWith(oldClassName)) {
      element.classList.remove(className);
      element.classList.add(newClassName);
    }
  });
}

//Close the item when clicking outside
function clickOutside() {
  /*

    Attach attribute data-close-container="identifier" to the element outside which you want to the click to register
    attach attribute data-close-target="identifier" to the element you want to close, attach data-close-class="class-name" to the [data-close-container] element and define the class you want to remove from [data-close-target] element upon clicking outside the [data-close-container]. Class name defaults to 'is-visible'
  */
  'use strict';

  // Add event listener to the whole body
  document.body.addEventListener('click', function (event) {
    // Select all elements with the attribute `data-close-container`
    document.querySelectorAll('[data-close-container]').forEach(function (closeContainer) {
      const closeTargetAttr = closeContainer.getAttribute('data-close-container');
      const closeTarget = document.querySelector(`[data-close-target="${closeTargetAttr}"]`);
      const closeClass = closeContainer.getAttribute('data-close-class') || 'is-visible';

      // Check if the click is outside of the closeContainer
      if (!closeContainer.contains(event.target) && closeContainer !== event.target) {
        closeTarget.classList.remove(closeClass);
      }
    });
  });
}

//Reset animation
function resetAnimation(img) {
  const newImg = new Image();
  newImg.src = img.src;
  newImg.onload = () => (img.src = newImg.src);
}

function resetAnimationSafari(img) {
  fetch(img.src)
    .then(response => response.blob())
    .then(blob => {
      const objectURL = URL.createObjectURL(blob);
      img.src = '';
      void img.offsetWidth;
      img.src = objectURL;
    });
}

function isSafari() {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('safari') && !userAgent.includes('chrome');
}

document.addEventListener('DOMContentLoaded', function (e) {
  //Open / Close Navigation
  const mainNav = document.querySelector('nav');
  const menuTrigger = document.querySelector('.mobile-menu-trigger');
  menuTrigger.addEventListener('click', () => {
    mainNav.classList.toggle('mob-menu-is-active');
  });

  //Start Testimonial Carousel
  const testimonials = document.querySelector('.testimonials');
  setTimeout(() => {
    testimonials.classList.add('is-running');
  }, 4000);

  //Open / Close Modals
  const modalWrapper = document.querySelector('.modal-wrapper');
  const modalTriggers = modalWrapper.querySelectorAll('.modal-trigger');
  modalWrapper.addEventListener('click', (e) => {
    const target = e.target;
    if (target.matches('.modal-trigger')) {
      modalTriggers.forEach((btn) => {
        //Prevent modal trigger flashing
        if (btn !== target && !btn.classList.contains('is-clicked')) {
          btn.classList.add('not-clicked');
        }
      });
      target.classList.toggle('is-clicked');
      target.classList.remove('not-clicked');

    }
    else if (target.matches('.modal-overlay')) {
      document.querySelector('.modal-trigger.is-clicked').classList.remove('is-clicked');
    }
  });

  //Close the item when clicking outside
  clickOutside();

});

document.addEventListener('DOMContentLoaded', function (e) {
  const figWomanContainer = document.querySelector('.fig-woman');
  let scrollDirection;
  let oldScrollY = window.scrollY;
  let onLoad = true;
  let vpHeight = viewport().height;
  const pi2ProbImg = document.querySelector('.pi-to-prob-fig');
  const prob2SolImg = document.querySelector('.prob-to-sol-fig');
  const prob2PiImg = document.querySelector('.prob-to-pi-fig');
  const sol2ProbImg = document.querySelector('.sol-to-prob-fig');
  const isSaf = isSafari();

  //Remove transition on load
  if (onLoad) {
    document.body.classList.add('on-load');
    onLoad = false;
    setTimeout(() => {
      document.body.classList.remove('on-load');
    }, 700);
  }

  //Check scroll direction
  window.onscroll = function (e) {
    scrollDirection = oldScrollY < window.scrollY ? 'down' : 'up';
    oldScrollY = window.scrollY;
  };

  //Handle woman figure visibility
  function handleIntersection(entries) {
    const homeHero = document.querySelector('#home-hero');
    const homeProblem = document.querySelector('#home-problem');
    const homeSolution = document.querySelector('#home-solution');

    const showTransition = (className, delay = 1000) => {
      figWomanContainer.classList.add(className);
      setTimeout(() => {
        figWomanContainer.classList.remove(className);
      }, delay);
    };

    const handleScrollDown = () => {
      if (homeHero.classList.contains('is-visible') && homeProblem.classList.contains('is-visible')) {
        // Show pi to prob;
        if (isSaf) {
          resetAnimationSafari(pi2ProbImg);
        } else {
          resetAnimation(pi2ProbImg);
        }
        showTransition('show-pi-to-prob');
      } else if (homeProblem.classList.contains('is-visible') && homeSolution.classList.contains('is-visible')) {
        // Show prob to sol
        if (isSaf) {
          resetAnimationSafari(prob2SolImg);
        } else {
          resetAnimation(prob2SolImg);
        }
        showTransition('show-prob-to-sol', 1100);
      }
    };

    const handleScrollUp = () => {
      if (homeHero.classList.contains('is-visible') && !homeProblem.classList.contains('is-visible') && oldScrollY !== 0) {
        // Show prob to pi
        if (isSaf) {
          resetAnimationSafari(prob2PiImg);
        } else {
          resetAnimation(prob2PiImg);
        }
        showTransition('show-prob-to-pi');
      } else if (homeProblem.classList.contains('is-visible') && !homeSolution.classList.contains('is-visible')) {
        // Show sol to prob
        if (isSaf) {
          resetAnimationSafari(sol2ProbImg);
        } else {
          resetAnimation(sol2ProbImg);
        }
        showTransition('show-sol-to-prob', 1500);
      }
    };

    entries.forEach(({ isIntersecting, target }) => {
      if (isIntersecting) {
        target.classList.add('is-visible');
        if (scrollDirection === 'down') {
          handleScrollDown();
        }
      } else {
        target.classList.remove('is-visible');
        if (scrollDirection === 'up') {
          handleScrollUp();
        }
      }
    });
  }

  const thresholdValue = vpHeight <= 800 ? 0.1 : 0.3;
  const observerOptions = { threshold: thresholdValue };
  const observer = new IntersectionObserver(handleIntersection, observerOptions);

  document.querySelectorAll('.group').forEach(section => {
    observer.observe(section);
  });

  //Handle figure woman top position
  function getElementDistanceFromTop(elementID) {
    const element = document.getElementById(elementID);
    return element ? element.offsetTop : 0;
  }

  // Create or update the <style> tag
  let style =
    document.querySelector('#fixed-styles') ||
    (() => {
      let s = document.createElement('style');
      s.id = 'fixed-styles';
      document.head.appendChild(s);
      return s;
    })();

  function updateFixedStyles() {
    const problemDistance = getElementDistanceFromTop('home-problem');
    const solutionDistance = getElementDistanceFromTop('home-solution');

    // Define CSS rules with dynamic values
    const css = `
        body:has(#home-problem.is-visible):not(:has(#home-solution.is-visible)) .fig-woman {
          top: calc(${problemDistance}px + 200px);
        }
        body:has(#home-solution.is-visible):not(:has(#home-product.is-visible)) .fig-woman,
        body:has(#home-product.is-visible) .fig-woman {
          top: calc(${solutionDistance}px + 90px);
        }
      `;

    style.textContent = css;
  }

  // Initial update of styles
  setTimeout(updateFixedStyles, 400);
  updateFixedStyles();

  // Update styles if the window is resized
  window.addEventListener('resize', updateFixedStyles);

  //Handle content visibility
  function handleContentIntersection(entries) {
    entries.forEach(({ isIntersecting, target }) => {
      if (isIntersecting) {
        target.classList.add('is-visible');
      } else {
        target.classList.remove('is-visible');
      }
    });
  }
  const contentObserverOptions = { threshold: 0.2 };
  const contentObserver = new IntersectionObserver(handleContentIntersection, contentObserverOptions);
  document.querySelectorAll('.group .container').forEach(container => {
    contentObserver.observe(container);
  });
});

document.addEventListener('DOMContentLoaded', function () {

  /////////////////////////////////////////////////////////////////////////
  // Helper functions - defined at top level for proper scope
  /////////////////////////////////////////////////////////////////////////

  // Submit data to Google Apps Script
  function submitToGoogleAppsScript(formDataObj) {
    // Collect metadata
    const quizData = {
      ...formDataObj,
      'user_agent': navigator.userAgent || '',
      'referrer': document.referrer || '',
      'created_at': new Date().toISOString(),
      'ip': ''
    };

    // Return a promise that resolves when the script loads
    return new Promise(function(resolve, reject) {
      // Try to get IP address first
      fetch('https://api.ipify.org?format=json')
        .then(function(response) { return response.json(); })
        .then(function(ipData) {
          quizData.ip = ipData.ip || '';
        })
        .catch(function(error) {
          console.log('Could not fetch IP address:', error);
        })
        .finally(function() {
          // Submit to Google Apps Script using script tag (bypasses CORS completely)
          const baseUrl = 'https://script.google.com/macros/s/AKfycbzTdiRn77geNC8hEaMos5OdjDCIG0pd0gnGDa_pgmpMQ2gi7y9GN5L_VTI9lE57-36U/exec';
          const params = new URLSearchParams();

          // Add all data as URL parameters
          Object.keys(quizData).forEach(function(key) {
            params.append(key, quizData[key]);
          });

          // Create unique callback name
          const callbackName = 'googleScriptCallback_' + Date.now();

          // Define global callback function
          window[callbackName] = function(response) {
            delete window[callbackName];
            document.body.removeChild(script);
            resolve(response);
          };

          // Create script tag
          const script = document.createElement('script');
          script.src = baseUrl + '?' + params.toString() + '&callback=' + callbackName;
          script.onerror = function() {
            delete window[callbackName];
            document.body.removeChild(script);
            reject(new Error('Script load failed'));
          };

          // Add script to page
          document.body.appendChild(script);
        });
    });
  }

  // Display results with product info and update speech bubble
  function displayResults(recommendedLevel, productData) {
    console.log("displayResults called with:", { recommendedLevel, productData });

    // Update speech bubble to show "OK! Here's what I've got..."
    const speechBubble = document.querySelector('.quiz-question-step-12');
    if (speechBubble) {
      speechBubble.innerHTML = '<p>OK! Here\'s what I\'ve got for you based on your unique selections:</p>';
    }

    // Show results div
    const resultsDiv = document.getElementById('quiz-results');
    console.log("Results div found:", !!resultsDiv);

    if (resultsDiv) {
      resultsDiv.style.display = 'block';

      // Populate product information from Google Apps Script response
      if (productData) {
        const productName = document.getElementById('product-name');
        const productImage = document.getElementById('product-image');
        const productDescription = document.getElementById('product-description');
        const discountCode = document.getElementById('discount-code');

        console.log("Product elements found:", {
          productName: !!productName,
          productImage: !!productImage,
          productDescription: !!productDescription,
          discountCode: !!discountCode
        });

        if (productName) productName.textContent = productData.name || recommendedLevel;
        if (productImage) {
          console.log("Setting image src to:", productData.image);
          productImage.src = productData.image || '';
          productImage.alt = productData.name || recommendedLevel;

          // Update height after image loads
          productImage.onload = function() {
            const quizSteps = document.querySelector('.quiz-steps');
            const step12Element = document.querySelector('.quiz-step-12');
            if (step12Element && quizSteps) {
              const newHeight = step12Element.offsetHeight;
              quizSteps.style.height = `${newHeight}px`;
              console.log("Updated quiz height after image load:", newHeight);
            }
          };
        }
        if (productDescription) productDescription.textContent = productData.description || '';
        if (discountCode) discountCode.textContent = productData.discountCode || 'THANKYOU10';

        // Set all product links
        const productLink = document.getElementById('product-link');
        const productLinkName = document.getElementById('product-link-name');
        const productLinkButton = document.getElementById('product-link-button');

        console.log("Link elements found:", {
          productLink: !!productLink,
          productLinkName: !!productLinkName,
          productLinkButton: !!productLinkButton
        });

        if (productLink) {
          console.log("Setting productLink href to:", productData.url);
          productLink.href = productData.url || '#';
        }
        if (productLinkName) {
          console.log("Setting productLinkName href to:", productData.url);
          productLinkName.href = productData.url || '#';
        }
        if (productLinkButton) {
          console.log("Setting productLinkButton href to:", productData.url);
          productLinkButton.href = productData.url || '#';
        }

        // Setup PDF button
        const viewPdfBtn = document.getElementById('view-pdf-btn');
        console.log("PDF button found:", !!viewPdfBtn);

        const pdfMap = {
          'No Personal Shield': 'no_personal_shield.pdf',
          'Level 2 BioElectric Shield': 'BioElectricShield_Level_2_Recommendation.pdf',
          'Level 2 Shield with Focusing': 'BioElectricShield_Level_2_with_focusing_Recommendation.pdf',
          'Level 3 BioElectric Shield': 'BioElectricShield_Level_3_Recommendation.pdf',
          'Level 3 Shield with Focusing': 'BioElectricShield_Level_3_with_focusing_Recommendation.pdf',
          'Level 4 BioElectric Shield': 'BioElectricShield_Level_4_Recommendation.pdf',
          'Level 4 Shield with Focusing': 'BioElectricShield_Level_4_with_focusing_Recommendation.pdf',
        };
        const pdfFile = pdfMap[recommendedLevel];
        const pdfUrl = pdfFile ? `https://static.bioelectricshield.com/pdf/${pdfFile}` : '';
        console.log("PDF URL being set:", pdfUrl, "for level:", recommendedLevel);

        if (viewPdfBtn && pdfUrl) {
          viewPdfBtn.setAttribute('data-pdf-url', pdfUrl);
          console.log("PDF URL successfully set on button");
        } else {
          console.error("Could not set PDF URL. Button exists:", !!viewPdfBtn, "URL exists:", !!pdfUrl);
        }
      }
    }
  }

  // PDF Lightbox Functions
  function openPDFLightbox(pdfUrl) {
    console.log("openPDFLightbox called with URL:", pdfUrl);

    try {
      let lightbox = document.getElementById('pdf-lightbox');
      console.log("Existing lightbox found:", !!lightbox);

      // Create lightbox if it doesn't exist
      if (!lightbox) {
        console.log("Creating new lightbox...");
        lightbox = document.createElement('div');
        lightbox.id = 'pdf-lightbox';
        lightbox.className = 'pdf-lightbox';
        lightbox.innerHTML = `
          <div class="pdf-lightbox-content">
            <span class="pdf-lightbox-close">&times;</span>
            <div class="pdf-iframe-container">
              <iframe id="pdf-iframe" src=""></iframe>
            </div>
          </div>
        `;
        document.body.appendChild(lightbox);
        console.log("Lightbox created and appended to body");

        // Close button functionality
        lightbox.querySelector('.pdf-lightbox-close').addEventListener('click', function() {
          closePDFLightbox();
        });

        // Close when clicking outside
        lightbox.addEventListener('click', function(e) {
          if (e.target === lightbox) {
            closePDFLightbox();
          }
        });

        // Close with Escape key
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') {
            closePDFLightbox();
          }
        });
      }

      // Set PDF URL and show lightbox
      const iframe = document.getElementById('pdf-iframe');
      console.log("PDF iframe found:", !!iframe);

      if (iframe) {
        iframe.src = pdfUrl;
        console.log("PDF URL set on iframe:", pdfUrl);
      }

      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
      console.log("Lightbox should now be visible");
    } catch (error) {
      console.error("Error in openPDFLightbox:", error);
    }
  }

  function closePDFLightbox() {
    const lightbox = document.getElementById('pdf-lightbox');
    if (lightbox) {
      lightbox.classList.remove('active');
      const iframe = document.getElementById('pdf-iframe');
      if (iframe) iframe.src = ''; // Clear iframe
      document.body.style.overflow = ''; // Restore scrolling
    }
  }

  // Setup PDF button click handler (at document level)
  document.addEventListener('click', function(e) {
    console.log("Click detected on:", e.target.id, e.target.className);

    // Check if the clicked element or its parent is the PDF button
    const pdfButton = e.target.id === 'view-pdf-btn' ? e.target : e.target.closest('#view-pdf-btn');

    if (pdfButton) {
      e.preventDefault();
      e.stopPropagation();
      console.log("PDF button clicked!");
      const pdfUrl = pdfButton.getAttribute('data-pdf-url');
      console.log("PDF URL from button:", pdfUrl);

      if (pdfUrl) {
        console.log("Opening PDF lightbox with URL:", pdfUrl);
        openPDFLightbox(pdfUrl);
      } else {
        console.error("No PDF URL found on button!");
      }
    }
  }, true); // Use capture phase

  /////////////////////////////////////////////////////////////////////////
  // Main quiz initialization
  /////////////////////////////////////////////////////////////////////////
  function initializeQuiz() {
    // All your normal variable declarations, including the 0-initialized shield values
    let vpWidth = viewport().width;
    const q2AImg = document.querySelector('.figure-q-to-a');
    const q2A2qImg = document.querySelector('.figure-q-to-a-to-q');
    const quiz = document.querySelector('#section-quiz');
    const quizContent = document.querySelector('#section-quiz .content');
    const quizContentSubtitle = quizContent.querySelector('.subtitle');
    const quizContentSubtitleMarginBtm = quizContentSubtitle
      ? parseInt(getComputedStyle(quizContentSubtitle).marginBottom)
      : 0;
    const quizContentTitle = quizContent.querySelector('h2');
    const quizDialogContainer = document.querySelector('.quiz-dialog-container');
    const stepTriggers = document.querySelectorAll('[data-step-trigger]');
    const lastStepTrigger = stepTriggers[stepTriggers.length - 1].dataset.stepTrigger;
    const secondToLastStepTrigger = stepTriggers[stepTriggers.length - 2].dataset.stepTrigger;
    const stepTargets = document.querySelectorAll('.quiz-step');
    const quizSteps = document.querySelector('.quiz-steps');
    const firstQuestion = document.querySelector('.quiz-question-step-1');
    const startQuestionMarginBottomMobile = 150;
    const startQuestionPaddingTopMobile = 24;
    const questionMarginBottom = 26;
    const questionPadding = 40;
    const resultField = document.querySelector('#result'); // the hidden "Recommended Shield" field
    let customTerm = '';
    const questionCustomTerm = document.querySelector('.custom-term');
    const speechBubbleStep12 = document.querySelector('.quiz-question-step-12');
    const downloadBoxTitle = document.querySelector('.download-box-title');
    const downloadBoxLead = document.querySelector('.download-box-lead');
    const isSaf = isSafari();

    // Recommendation texts for each shield level (with complete product data as fallback)
    const recommendationTexts = {
      'No Personal Shield': {
        title: 'You might not need a personal shield right now!',
        lead: 'Based on your answers, it seems you are not experiencing significant issues that require a personal shield.',
        link: 'https://bioelectricshield.com/collections/all',
        image: 'https://bioelectricshield.com/cdn/shop/files/level-1-pendant.jpg',
        description: 'Based on your answers, you may not need a personal shield at this time. Explore our wellness resources for maintaining your balance.',
      },
      'Level 2 BioElectric Shield': {
        title: 'A Level 2 BioElectric Shield is recommended for you!',
        lead: 'Our Level 2 Shield provides excellent protection and is suitable for your needs.',
        link: '/discount/THANKYOU10?redirect=/categories/level-2-essential-plus',
        image: 'https://bioelectricshield.com/cdn/shop/files/level-2-pendant.jpg',
        description: 'Perfect for moderate sensitivity. Provides balanced protection for everyday EMF exposure and environmental stressors.',
      },
      'Level 2 Shield with Focusing': {
        title: 'Consider a Level 2 Shield with Focusing!',
        lead: 'This shield not only offers protection but also enhances focus.',
        link: '/discount/THANKYOU10?redirect=/categories/focusing-level-2',
        image: 'https://bioelectricshield.com/cdn/shop/files/level-2-focusing.jpg',
        description: 'Level 2 protection enhanced with focusing elements to help maintain clarity and concentration.',
      },
      'Level 3 BioElectric Shield': {
        title: 'We recommend a Level 3 BioElectric Shield!',
        lead: 'For stronger protection, the Level 3 Shield is ideal based on your responses.',
        link: '/discount/THANKYOU10?redirect=/categories/level-3-premium',
        image: 'https://bioelectricshield.com/cdn/shop/files/level-3-pendant.jpg',
        description: 'Recommended for high sensitivity. Advanced protection for frequent EMF exposure and challenging environments.',
      },
      'Level 3 Shield with Focusing': {
        title: 'A Level 3 Shield with Focusing is perfect for you!',
        lead: 'Enhanced protection + focus match your needs.',
        link: '/discount/THANKYOU10?redirect=/categories/focusing-level-3',
        image: 'https://bioelectricshield.com/cdn/shop/files/level-3-focusing.jpg',
        description: 'Level 3 protection with enhanced focusing capabilities for optimal performance and protection.',
      },
      'Level 4 BioElectric Shield': {
        title: 'A Level 4 BioElectric Shield is the best choice for you!',
        lead: 'Our highest level of protection is recommended based on your answers.',
        link: '/discount/THANKYOU10?redirect=/categories/level-4-ultimate',
        image: 'https://bioelectricshield.com/cdn/shop/files/level-4-pendant.jpg',
        description: 'Maximum protection for extreme sensitivity. Our most powerful shield for comprehensive defense against EMF and energy disturbances.',
      },
      'Level 4 Shield with Focusing': {
        title: 'The Level 4 Shield with Focusing is highly recommended!',
        lead: 'Maximum protection and enhanced focus align with your needs.',
        link: '/discount/THANKYOU10?redirect=/categories/focusing-level-4',
        image: 'https://bioelectricshield.com/cdn/shop/files/level-4-focusing.jpg',
        description: 'The ultimate protection combined with maximum focusing support for peak performance and comprehensive shielding.',
      },
    };

    // Initialize shield variables
    let noPersonalShield = 0;
    let level2BioelectricShield = 0;
    let level2ShieldWithFocusing = 0;
    let level3BioelectricShield = 0;
    let level3ShieldWithFocusing = 0;
    let level4BioelectricShield = 0;
    let level4ShieldWithFocusing = 0;
    let highestScore;
    let highestScoringVariable;

    // Store each step's answers in an object
    const quizData = {};

    // Function that updates shield values based on each answer
    function updateShieldValues(answer) {
      switch (answer) {
        case 'q-1-a':
        case 'q-2-a':
        case 'q-3-a':
        case 'q-4-a':
        case 'q-5-a':
        case 'q-6-a':
        case 'q-9-a':
          noPersonalShield += 5;
          level2BioelectricShield += 3;
          level2ShieldWithFocusing += 3;
          break;

        case 'q-1-b':
        case 'q-2-b':
        case 'q-3-b':
        case 'q-4-b':
        case 'q-5-b':
        case 'q-6-b':
        case 'q-9-b':
          level2BioelectricShield += 5;
          level2ShieldWithFocusing += 5;
          level3BioelectricShield += 5;
          level3ShieldWithFocusing += 5;
          break;

        case 'q-1-c':
        case 'q-2-c':
        case 'q-3-c':
        case 'q-4-c':
        case 'q-5-c':
        case 'q-6-c':
        case 'q-9-c':
          level3BioelectricShield += 10;
          level3ShieldWithFocusing += 10;
          break;

        case 'q-1-d':
        case 'q-2-d':
        case 'q-3-d':
        case 'q-4-d':
        case 'q-5-d':
        case 'q-6-d':
        case 'q-9-d':
          level3BioelectricShield += 10;
          level3ShieldWithFocusing += 10;
          level4BioelectricShield += 10;
          level4ShieldWithFocusing += 10;
          break;

        case 'q-7-a':
        case 'q-7-b':
        case 'q-7-c':
        case 'q-7-d':
          // noPersonalShield += 0;
          break;

        case 'q-8-a':
        case 'q-8-b':
        case 'q-8-d':
        case 'q-8-f':
          level3BioelectricShield += 10;
          level3ShieldWithFocusing += 10;
          level4BioelectricShield += 10;
          level4ShieldWithFocusing += 10;
          break;

        case 'q-8-c':
          level2BioelectricShield += 4;
          level2ShieldWithFocusing += 4;
          level3BioelectricShield += 10;
          level3ShieldWithFocusing += 10;
          level4BioelectricShield += 10;
          level4ShieldWithFocusing += 10;
          break;

        case 'q-8-e':
          level2BioelectricShield += 5;
          level2ShieldWithFocusing += 5;
          level3BioelectricShield += 10;
          level3ShieldWithFocusing += 10;
          level4BioelectricShield += 10;
          level4ShieldWithFocusing += 10;
          break;

        case 'q-9-a':
          noPersonalShield += 5;
          level2BioelectricShield += 2;
          level2ShieldWithFocusing += 2;
          break;

        case 'q-10-a':
          level2ShieldWithFocusing += 10;
          level3ShieldWithFocusing += 10;
          level4ShieldWithFocusing += 10;
          break;

        case 'q-10-b':
          level2ShieldWithFocusing -= 1;
          level3ShieldWithFocusing -= 1;
          level4ShieldWithFocusing -= 1;
          break;

        default:
          break;
      }
    }

    // Helper function for getting biggest height
    function getBiggestHeight(elements) {
      let maxHeight = 0;
      elements.forEach((element) => {
        const height = element.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      return maxHeight;
    }

    /////////////////////////////////////////////////////////////////////////
    // Main logic: steps, answer selection, final submission
    /////////////////////////////////////////////////////////////////////////
    if (stepTriggers && stepTargets && quizSteps) {

      // Set up an object for each step so we know if it has radio or checkboxes
      stepTargets.forEach((step) => {
        const stepNumber = step.dataset.step;
        const isRadio = step.querySelector('input[type="radio"]') !== null;
        const isCheckbox = step.querySelector('input[type="checkbox"]') !== null;

        if (isRadio) {
          quizData[stepNumber] = { value: '', label: '' };
        }
        if (isCheckbox) {
          quizData[stepNumber] = { values: [], labels: [] };
        }
      });

      // For fancy figure animations
      const animatedSteps = Object.keys(quizData).filter((step) => step !== 'step-1');

      // Set the quiz's container height to whichever step is tallest
      function setQuizHeight() {
        const biggestHeight = getBiggestHeight(stepTargets);
        quizSteps.style.height = `${biggestHeight}px`;
      }

      document.fonts.ready.then(function () {
        // Position first question bubble
        const firstQuestionHeight =
          firstQuestion.querySelector('p').offsetHeight +
          firstQuestion.querySelector('span').offsetHeight +
          questionPadding;
        const initialFirstQuestionPosition = firstQuestion
          ? (firstQuestionHeight + questionMarginBottom) / 2
          : 0;

        quizDialogContainer.style.paddingTop = `${initialFirstQuestionPosition}px`;

        stepTargets.forEach((step) => {
          if (!step.classList.contains('quiz-start')) {
            step.querySelector('.content').style.paddingTop =
              `${initialFirstQuestionPosition * 2}px`;
          }
        });

        // On desktop, set quiz container height
        // On mobile, handle differently
        if (vpWidth < 640) {
          if (quizSteps.dataset.step === 'step-0') {
            quizSteps.style.height = `${
              document.querySelector('.quiz-start .button-wrapper').offsetHeight +
              document.querySelector('.quiz-start .speech-bubble p').offsetHeight +
              questionPadding +
              startQuestionMarginBottomMobile +
              startQuestionPaddingTopMobile
            }px`;
            quizContent.style.height = `${
              quizContentSubtitle.offsetHeight +
              quizContentTitle.offsetHeight +
              quizContentSubtitleMarginBtm
            }px`;
          }
        } else {
          setQuizHeight();
        }
      });

      window.addEventListener('resize', () => {
        vpWidth = viewport().width;
        if (vpWidth < 640) {
          if (quizSteps.dataset.step === 'step-0') {
            quizSteps.style.height = `${document.querySelector('.quiz-start').offsetHeight}px`;
            quizContent.style.height = `${
              quizContentSubtitle.offsetHeight +
              quizContentTitle.offsetHeight +
              quizContentSubtitleMarginBtm
            }px`;
          } else {
            quizContent.style.height = 0;
          }
        } else {
          quizContent.style.height = 'auto';
          setQuizHeight();
        }
      });

      // Step transition click handler
      quizSteps.addEventListener('click', (e) => {
        e.stopPropagation();

        if (e.target.matches('[data-step-trigger]')) {
          e.preventDefault();
          const trigger = e.target;
          const triggerTarget = quizSteps;
          const targetIdentifier = trigger.dataset.stepTrigger;
          const currentStep = triggerTarget.dataset.step;
          const nextTrigger = document.querySelector(`.quiz-${targetIdentifier} [data-step-trigger]`);

          if (vpWidth < 640) {
            const nextStepElem = document.querySelector(`.quiz-${targetIdentifier}`);
            if (nextStepElem) {
              quizSteps.style.height = nextStepElem.offsetHeight + "px";
            }
          }

          const stepAnswer = document.querySelector(`.quiz-answer-${currentStep}`);
          const currentQuestion = document.querySelector(`.quiz-question-${currentStep}`);
          const nextQuestion = document.querySelector(`.quiz-question-${targetIdentifier}`);
          const currentPosition = firstQuestion
            ? parseInt(getComputedStyle(firstQuestion).marginTop) * -1
            : 0;
          const initialMovementDistance = stepAnswer
            ? (stepAnswer.offsetHeight + questionMarginBottom)
            : 0;
          const secondMovementDistance = nextQuestion
            ? (nextQuestion.offsetHeight + questionMarginBottom)
            : 0;

          triggerTarget.dataset.step = targetIdentifier;
          replaceCSSClass(quiz, 'is-step', `is-${targetIdentifier}`);

          // On mobile, hide quiz content if going to step-1
          if (vpWidth < 640 && targetIdentifier == 'step-1') {
            quizContent.style.height = '0px';
          }

          if (stepAnswer) {
            // Move from old question to new
            firstQuestion.style.marginTop = `-${initialMovementDistance + currentPosition}px`;

            // Figure animations
            if ([...animatedSteps, secondToLastStepTrigger].includes(targetIdentifier)) {
              quiz.classList.remove('show-q');
              if (isSaf) resetAnimationSafari(q2A2qImg);
              else resetAnimation(q2A2qImg);

              quiz.classList.add('show-q-to-a-to-q');
              setTimeout(() => { quiz.classList.add('show-q'); }, 1100);

              setTimeout(() => {
                if (nextTrigger) nextTrigger.style.pointerEvents = 'auto';
              }, 1200);
            }
            else if (targetIdentifier == lastStepTrigger) {
              quiz.classList.remove('show-q-to-a-to-q');
              quiz.classList.remove('show-q');
              if (isSaf) resetAnimationSafari(q2AImg);
              else resetAnimation(q2AImg);

              quiz.classList.add('show-q-to-a');
              setTimeout(() => {
                quiz.classList.remove('show-q-to-a');
                quiz.classList.add('show-a');
              }, 500);
            }

            setTimeout(() => {
              const sum = initialMovementDistance + secondMovementDistance + currentPosition;
              firstQuestion.style.marginTop = `-${sum}px`;
              if (currentQuestion) currentQuestion.classList.add('is-blurred');
              if (stepAnswer) stepAnswer.classList.add('is-blurred');
            }, 500);

            // Step before last -> compute recommended shield
            if (targetIdentifier == secondToLastStepTrigger) {
              Object.keys(quizData).forEach((stepNo) => {
                if (quizData[stepNo].value) {
                  updateShieldValues(quizData[stepNo].value);
                }
                if (quizData[stepNo].values && quizData[stepNo].values.length > 0) {
                  quizData[stepNo].values.forEach((val) => updateShieldValues(val));
                }
              });

              // Tie-break logic
              highestScoringVariable = (() => {
                if (level3BioelectricShield === level4BioelectricShield) {
                  level4BioelectricShield = Math.max(level3BioelectricShield, level4BioelectricShield);
                }
                if (level3ShieldWithFocusing === level4ShieldWithFocusing) {
                  level4ShieldWithFocusing = Math.max(level3ShieldWithFocusing, level4ShieldWithFocusing);
                }
                if (level2BioelectricShield === level3BioelectricShield) {
                  level3BioelectricShield = Math.max(level2BioelectricShield, level3BioelectricShield);
                }
                if (level2ShieldWithFocusing === level3ShieldWithFocusing) {
                  level3ShieldWithFocusing = Math.max(level2ShieldWithFocusing, level3ShieldWithFocusing);
                }

                highestScore = Math.max(
                  noPersonalShield,
                  level2BioelectricShield,
                  level2ShieldWithFocusing,
                  level3BioelectricShield,
                  level3ShieldWithFocusing,
                  level4BioelectricShield,
                  level4ShieldWithFocusing
                );

                switch (highestScore) {
                  case noPersonalShield:              return 'No Personal Shield';
                  case level4BioelectricShield:       return 'Level 4 BioElectric Shield';
                  case level4ShieldWithFocusing:      return 'Level 4 Shield with Focusing';
                  case level3BioelectricShield:       return 'Level 3 BioElectric Shield';
                  case level3ShieldWithFocusing:      return 'Level 3 Shield with Focusing';
                  case level2BioelectricShield:       return 'Level 2 BioElectric Shield';
                  case level2ShieldWithFocusing:      return 'Level 2 Shield with Focusing';
                  default:                             return 'No highest scoring shield';
                }
              })();

              // Change text for question-step-11
              customTerm = 'inner harmony and overall well-being';
              if (questionCustomTerm) {
                questionCustomTerm.innerText = customTerm;
              }
            }
            // Last step => Just store the result
            else if (targetIdentifier == lastStepTrigger) {
              // Put final recommended shield into the hidden #result field
              resultField.value = highestScoringVariable;

              // Set initial height for final step, but allow it to grow
              const finalStepEl = document.querySelector(`.quiz-${targetIdentifier}`);
              if (finalStepEl) {
                const initialHeight = finalStepEl.offsetHeight;
                quizSteps.style.minHeight = `${initialHeight}px`;
                quizSteps.style.height = 'auto';
              }
            }
          }
          else {
            // Fallback negative margin
            firstQuestion.style.marginTop = `-${
              (secondMovementDistance + currentPosition) / 2
            }px`;
          }
        }
        else if (
          e.target.tagName === 'INPUT' &&
          (e.target.type === 'radio' || e.target.type === 'checkbox')
        ) {
          // Handling user's choice
          const target = e.target;
          const step = target.name; // e.g. "step-1"
          const value = target.value;
          const labelElement = document.querySelector(`label[for="${target.id}"] .choice-title`);
          const label = labelElement ? labelElement.innerText : '';
          const continueButton = document.querySelector(`.quiz-${step} .button`);
          const stepAnswer = document.querySelector(`.quiz-answer-${step}`);

          if (target.type === 'radio') {
            quizData[step].value = value;
            quizData[step].label = label;
            if (stepAnswer) {
              stepAnswer.innerText = label;
            }
          } else {
            // It's a checkbox question
            const i = quizData[step].values.indexOf(value);
            const j = quizData[step].labels.indexOf(label);

            if (i === -1) {
              quizData[step].values.push(value);
            } else {
              quizData[step].values.splice(i, 1);
            }

            if (j === -1) {
              quizData[step].labels.push(label);
            } else {
              quizData[step].labels.splice(j, 1);
            }

            if (stepAnswer) {
              stepAnswer.innerText = quizData[step].labels.join(', ');
            }
          }

          // Enable "Continue" if there's at least 1 selection
          if (continueButton) {
            continueButton.disabled = !(quizData[step].value || quizData[step].values.length > 0);
          }
        }
      });

      /////////////////////////////////////////////////////////////////////////
      // Final form submission (no reload), send to Google Apps Script
      /////////////////////////////////////////////////////////////////////////
      const downloadForm = document.querySelector('form[name="download"]');
      if (downloadForm) {
        downloadForm.addEventListener('submit', async function (e) {
          console.log("Download form submit triggered");
          e.preventDefault(); // No page reload

          // Get the submit button
          const submitButton = downloadForm.querySelector('button[type="submit"]');
          const originalButtonText = submitButton ? submitButton.textContent : '';

          // Add loading state to button
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.classList.add('button-loading');
            submitButton.textContent = 'Submitting...';
          }

          // 1) Grab the user's email
          const emailInput = document.getElementById('email');
          const email = emailInput ? emailInput.value : "";

          // 2) The recommended shield from #result
          const recommendedLevel = resultField.value;

          // 3) Fill the hidden fields with user answers
          Object.keys(quizData).forEach((stepNumber) => {
            const stepData = quizData[stepNumber];
            const hiddenField = document.querySelector('#answer-' + stepNumber);
            if (!hiddenField) return;

            if (stepData.value) {
              // Radio single answer
              hiddenField.value = stepData.label;
            }
            else if (stepData.values && stepData.values.length > 0) {
              // Checkbox multiple answers
              hiddenField.value = stepData.labels.join(', ');
            }
            else {
              hiddenField.value = "";
            }
          });

          // 4) Build data object for Google Apps Script
          const formDataToSend = {
            "email": email,
            "Recommended Shield Level": recommendedLevel
          };

          // Also gather each hidden field's name + final .value
          const allHiddenFields = downloadForm.querySelectorAll('input[type="hidden"]');
          allHiddenFields.forEach(field => {
            const fieldName = field.getAttribute('name');
            const fieldValue = field.value || "";
            // Only add fields that match our quiz questions
            if (fieldName && fieldValue && fieldName !== "form-name") {
              formDataToSend[fieldName] = fieldValue;
            }
          });

          // 5) Send to Google Apps Script FIRST (and wait for it)
          try {
            const data = await submitToGoogleAppsScript(formDataToSend);

            if (data.ok) {
              console.log("Successfully sent to Google Apps Script!");
              console.log("Full response data:", data);
              console.log("Product data received:", data.product);
              console.log("Recommended level:", recommendedLevel);

              // Log Shopify subscription result
              if (data.shopify) {
                console.log("Shopify subscription:", data.shopify.message);
              }

              // Update speech bubble and download box with personalized recommendation
              const recommendation = recommendationTexts[recommendedLevel];
              if (recommendation) {
                // Update speech bubble with personalized title
                if (speechBubbleStep12) {
                  speechBubbleStep12.innerHTML = `<p>${recommendation.title}</p>`;
                }

                // Update download box title and lead
                if (downloadBoxTitle) {
                  downloadBoxTitle.innerText = recommendation.title;
                }
                if (downloadBoxLead) {
                  const linkText = `View options for your ${recommendedLevel}`;
                  downloadBoxLead.innerHTML = `${recommendation.lead} <a href="${recommendation.link}" target="_blank">${linkText}</a>`;
                }
              }

              // Hide form and display results with product info
              downloadForm.style.display = 'none';

              // Display results with product information from Google Apps Script
              // If product data is missing from server, use local recommendationTexts as fallback
              const productDataToUse = data.product || {
                name: recommendedLevel,
                image: recommendation.image,
                description: recommendation.description,
                url: recommendation.link,
                discountCode: 'THANKYOU10'
              };

              console.log("Product data being sent to displayResults:", productDataToUse);
              displayResults(recommendedLevel, productDataToUse);

              // Recalculate and update the quiz container height after results are displayed
              setTimeout(() => {
                const step12Element = document.querySelector('.quiz-step-12');
                if (step12Element && quizSteps) {
                  const newHeight = step12Element.offsetHeight;
                  quizSteps.style.height = `${newHeight}px`;
                  console.log("Updated quiz height to:", newHeight);
                }
              }, 100);

            } else {
              console.error("Error from Google Apps Script:", data.error);

              // Remove loading state on error
              if (submitButton) {
                submitButton.disabled = false;
                submitButton.classList.remove('button-loading');
                submitButton.textContent = originalButtonText;
              }

              alert("There was an error submitting your quiz. Please try again.");
            }
          } catch (err) {
            console.error("Error sending data to Google Apps Script:", err);

            // Remove loading state on error
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.classList.remove('button-loading');
              submitButton.textContent = originalButtonText;
            }

            alert("There was a network error. Please try again.");
          }
        });
      }
    } // end if (stepTriggers && stepTargets && quizSteps)
  }

  // Finally, run our quiz initialization
  initializeQuiz();

});

